import { ActivityEntityName } from '../shared/activity.entity.name';
import { ActivitySendSchedule } from '../shared/activity';
import { Attachment } from '../shared/attachment';
import { ContactSummary } from '../contact/contact';
import { Entity, EntityLink } from '../entity';

export enum MergeEngine {
    Mustache = 'Mustache',
    Aspose = 'Aspose'
}

export enum MergeType {
    EMAIL = 'email',
    SMS = 'sms',
    PDF = 'pdf'
}

export enum MergeStatus {
    Draft = 'Draft',
    Public = 'Public'
}

export interface EmailContext {
    entity: ActivityEntityName;
    entityId: string;
    sendFrom?: string;
    customer: Entity;
    themeId?: string;
    showMarkSent?: boolean;
    sendTo?: ContactSummary[];
}

export interface SenderEntity extends Entity {
    email: string;
    mobile: string;
}

export interface MergeTemplate extends Entity {

    subject: string;
    body: string;
    from: string;
    fromEntity?: SenderEntity;
    to: SenderEntity[];
    ccEntity?: SenderEntity[];
    bccEntity?: SenderEntity[];
    cc?: string[];
    bcc?: string[];
    entity: ActivityEntityName;
    entityId: string;
    status: MergeStatus;
    attachments?: Attachment[];
    markSent?: boolean;
    sendSchedule?: ActivitySendSchedule;

    type: MergeType;
    engine: MergeEngine;
    template?: any;
    themeId?: string;

    labels: Entity[]

    jobTypes?: Entity[];
    workCategories?: Entity[];
    companies?: Entity[];
    reportAttachments?: ReportAttachmentTemplate[];
}

export interface ReportAttachmentTemplate extends Entity {
    entity: ActivityEntityName;
}

export interface MergeTemplateScopeRequest {
    companyIds?: string[];
    jobTypes?: string[];
    workCategories?: string[];
    entityLink?: EntityLink;
}

export interface MergeTemplateRequest {
    merge: MergeTemplate;
    body: string;
}

export const toSimpleMergeTemplate = (value: string) => {
    const template = {
        template: value,
    } as MergeTemplate;

    return template;
}